module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-152x152-5aeb7ce6ff1d700b9be877d29d5975cf.png";